























































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';

import { Badge, CrudList, DataTable, NoDataFound } from '../../components';

import { ColorEnum } from '../../enums';

import { CrudListMixin } from '../../mixins/crud-list.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

export default {
  name: 'products-ranking-list',
  components: {
    Badge,
    CrudList,
    DataTable,
    NoDataFound
  },
  mixins: [CrudListMixin],
  data: function () {
    const messages = this.$epb.messages.tools.productsRanking;
    return {
      dataType: ActionTypeEnum.PRODUCTS_RANKING,
      routes: {
        create: ROUTER_CONSTS.routes.productsRanking.create,
        update: ROUTER_CONSTS.routes.productsRanking.update
      },
      columns: [
        {
          id: 'lang',
          text: this.$epb.messages.filters.names.lang,
          sortable: true
        }, {
          id: 'keywords',
          text: messages.fields.keywords.label,
          width: '200%'
        }, {
          id: 'elements',
          text: messages.fields.products.label
        }, {
          id: 'meta.updateDate',
          text: messages.fields.updateDate.label,
          sortable: true
        }, {
          id: 'enabled',
          text: messages.fields.enabled.label,
          sortable: true
        }
      ],
      messages: messages
    };
  },
  methods: {
    getKeywordsText: function (keywords: string[]) {
      return keywords.map((keyword: string) => `"${ keyword }"`).join(', ');
    },
    groupProductsByProperty: function (products, key) {
      return Object.entries(products.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item]
        }),
        {}
      )).sort();
    },
    getBadgeColor: function (action: RankingActionEnum): string {
      return {
        [RankingActionEnum.BOOST]: ColorEnum.GREEN,
        [RankingActionEnum.BURY]: ColorEnum.RED
      }[action];
    }
  }
};

